<template>
  <el-checkbox class="mine-ob" style="margin-right: 20px;" v-model="checked">{{onlyReal ? '仅查看执行任务' : '仅查看我执行的'}}</el-checkbox>
</template>
<script>
import { mapMutations, mapState } from 'vuex'
export default {
  props: ['onlyReal'],
  computed: {
    ...mapState('mine/mine', {
      my_execution: state => state.queryMsg.my_execution
    }),
    checked: {
      get() {
        return this.my_execution
      },
      set(val) {
        this.change(val)
      }
    }
  },
  data() {
    return {

    }
  },
  methods: {
    ...mapMutations('mine/mine', ['set_my_execution']),
    change(fl) {
      this.set_my_execution(fl)
    }
  }
}
</script>
<style lang="scss">
.mine-ob {
  display: flex;
  align-items: center;
  .el-checkbox__input.is-checked+.el-checkbox__label {
    color: rgba(32, 32, 32, 0.6);
  }
  .el-checkbox__input {
    line-height: 1px;

  }
  .el-checkbox__inner {
    width: 14px;
    height: 14px;
  }
  .el-checkbox__label {
    line-height: 1;
    color: rgba(32, 32, 32, 0.6);
    font-size: 14px;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner::after {
    top: 6px;
    left: 0;
  }
}
</style>
